<template>
  <div id="competition-category">
    <div id="resum_event">
      <div class="group_info" v-for="(group, key) in info_event_teams">
        <div
          class="group all"
          :class="{ selected: activeCategory == group.id }"
          @click="changeCategory(group.id)"
          v-if="group.id == -1"
        >
          <div class="name">{{ group.name }}</div>
        </div>
        <div
          class="group"
          v-else
          :class="{ selected: activeCategory == group.id }"
          @click="changeCategory(group.id)"
        >
          <div class="name">{{ group.max_age }}</div>
          <div class="year">{{ group.year }} ({{ group.objective }})</div>
        </div>
        <div class="info"></div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "CompetitionCategory",
  components: {},
  props: ["filters"],
  data() {
    return {};
  },
  computed: {
    categories() {
      var categoriesData = this.$store.getters[
        "events/getCategoriesEventSelected"
      ]();
      categoriesData.unshift({ id: -1, name: i18n.t("all") });
      return categoriesData;
    },

    activeCategory() {
      var category_selected = this.$store.getters[
        "competition/getCategorySelected"
      ];
      return category_selected ? category_selected : -1;
    },

    info_event_teams() {
      var aEvent = { ...this.$store.getters["events/getCurrentEvent"]() };
      var oCategories = { ...aEvent.categories };
      var aCategories = [];
      for (var k in oCategories) {
        var category = oCategories[k];
        aCategories.push(category);
      }
      aCategories.unshift({ id: -1, name: i18n.t("all") });
      return aCategories;
    }
  },
  created() {
    var self = this;
  },
  methods: {
    changeCategory(id) {
      this.$store.commit("competition/changeCategory", id);

      var filters = { ...this.filters };
      filters.category_id = id;

      this.$emit("applyFilters", filters);
    }
  }
};
</script>

<style lang="scss" scoped>
#competition-category {
  height: 60px;
  width: 100%;
  top: 110px;
  position: fixed;
  overflow: hidden;
  padding: 0;
  border-bottom: 1px solid #ddd;
  z-index: $z-topbar - 1;
  background-color: #fff;

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #fff;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #ddd;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }

  #resum_event,
  #group_resum {
    width: 100%;
    height: 60px;
    text-align: center;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    .group_info {
      border-radius: 3px;
      line-height: 50px;
      margin: 0px 5px;
      display: inline-block;
      padding: 6px 8px;

      .group {
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
        display: inline-block;
        background-color: #ddd;
        color: #fff;
        padding: 5px;
        border-radius: 3px;
        width: 90px;
        height: 40px;
        margin-top: 5px;
        text-align: center;
        float: left;
        /* margin-right: 5px; */
        cursor: pointer;

        & .all {
          .name {
            line-height: 40px;
          }
        }

        &.selected {
          background-color: #222;
          .name {
            color: white;
          }
        }

        .name {
          display: inline-block;
          width: 100%;
          font-size: 14px;
          line-height: 14px;
          margin: 0;
          color: #888;
          text-align: center !important;
          font-weight: bold;
          font-family: Roboto-Bold;
          height: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .year {
          display: inline-block;
          width: 100%;
          font-size: 12px;
          line-height: 12px;
          text-align: center !important;
          color: #999;
          display: block;
        }
      }
      .key {
        width: fit-content;
        display: inline-block;
        font-size: 12px;
        padding: 5px 5px;
        border-radius: 3px;
        text-align: center;
        margin-right: 5px;
        color: #444;
        text-transform: uppercase;
        border-left: 6px solid red;

        &[data-color="1"] {
          border-left-color: #ffc107;
        }
        &[data-color="2"] {
          border-left-color: #e91e63;
        }
        &[data-color="3"] {
          border-left-color: #673ab7;
        }
        &[data-color="4"] {
          border-left-color: #222;
        }
      }
      .info {
        width: fit-content;
        display: inline-block;
        padding: 0 5px;
        margin-top: 10px;

        .value {
          font-weight: bold;
          font-size: 16px;
          margin: 0 1px;
        }

        .objective {
          font-weight: lighter;
          font-size: 16px;
          padding: 0 1px;
        }

        .interest {
          font-weight: lighter;
          font-size: 16px;
          padding: 0 1px;
          color: #999;
        }
      }
    }
  }
}

.development #competition-category {
  top: calc(110px + #{$height-development});
}
</style>
